import { ProductState } from "../types/productTypes";
import { AnyAction } from "redux";
import {
  FETCH_PRODUCTS_REQUEST,
  FETCH_PRODUCTS_SUCCESS,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCTS_RESET,
} from "../actions/productActions";

const initialState: ProductState = {
  productsData: {
    products: [],
    moreProducts: [],
    similarProducts: [],
    totalRecords: 0,
    sellerInfo: {
      createdTime: 0,
      email: "",
      isVerified: false,
      name: "",
      stripeid: "",
      loginAttempts: 0,
    },
  },
  loading: false,
  error: null,
};

const productReducer = (
  state = initialState,
  action: AnyAction
): ProductState => {
  switch (action.type) {
    case FETCH_PRODUCTS_REQUEST:
      // Don't clear products immediately - keep old products visible until new ones arrive
      // This prevents blinking during the fetch
      return {
        ...state,
        loading: true,
        error: null,
        // Keep existing productsData to prevent blinking
      };
    case FETCH_PRODUCTS_SUCCESS:
      return {
        ...state,
        productsData: action.payload,
        loading: false,
        error: null,
      };
    case FETCH_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_PRODUCTS_RESET:
      return {
        ...state,
        productsData: {
          products: [],
          moreProducts: [],
          similarProducts: [],
          totalRecords: 0,
          sellerInfo: {
            createdTime: 0,
            email: "",
            isVerified: false,
            name: "",
            stripeid: "",
            loginAttempts: 0,
          },
        },
        loading: false,
        error: null,
      };
    // Handle other item-related actions here...
    default:
      return state;
  }
};

export default productReducer;
